const withdrawEnabledDomain = [
  { subdomain: "gr-mobimilia" }
];

export const isWithdrawEnabled = (subdomain) => {
  return withdrawEnabledDomain.some(
    (item) => item.subdomain === subdomain
  );
};